import { FileSelectField, FormFieldV2 as FormField, SearchFieldV2 as SearchField } from '@/components/custom/erp';
import { diaChiSearchColumns, khachHangSearchColumns, QUERY_KEYS } from '@/constants';

import { FormFieldActions, FormFieldState } from '../../hooks';
import { type DiaChi, KhachHang } from '@/types/schemas';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface OtherTabProps {
  formMode: FormMode;
  formState: {
    state: FormFieldState;
    actions: FormFieldActions;
  };
}

export default function OtherTab({ formMode, formState: { state, actions } }: OtherTabProps) {
  return (
    <div className='p-4'>
      <div className='flex flex-col justify-between lg:flex-row'>
        {/* Left column */}
        <div className='w-full space-y-1'>
          <div className='flex items-center'>
            <Label className='w-32 min-w-32 text-sm font-medium'>Nhóm sản phẩm</Label>
            <div className='flex-1'>
              <FormField name='ten_vt_thue' disabled={formMode === 'view'} />
            </div>
          </div>
          <div className='flex items-center'>
            <Label className='w-32 min-w-32 text-sm font-medium'>Cục thuế</Label>
            <SearchField<KhachHang>
              columnDisplay='customer_code'
              displayRelatedField='customer_name'
              searchEndpoint={`/${QUERY_KEYS.KHACH_HANG}`}
              searchColumns={khachHangSearchColumns}
              value={state.coQuanThue?.customer_code || ''}
              relatedFieldValue={state.coQuanThue?.customer_name || ''}
              onRowSelection={actions.setCoQuanThue}
              disabled={formMode === 'view'}
              dialogTitle='Danh mục đối tượng'
            />
          </div>
          <div className='flex items-center'>
            <Label className='w-32 min-w-32 text-sm font-medium'>Địa chỉ giao hàng</Label>
            <SearchField<DiaChi>
              type='text'
              columnDisplay='ma_dc'
              displayRelatedField='ten_dc'
              searchEndpoint={`/${QUERY_KEYS.DIA_CHI}`}
              searchColumns={diaChiSearchColumns}
              value={state.diaChiGiaoHang?.ma_dc || ''}
              relatedFieldValue={state.diaChiGiaoHang?.ten_dc || ''}
              onRowSelection={actions.setDiaChiGiaoHang}
              disabled={formMode === 'view'}
              dialogTitle='Danh mục đối tượng'
            />
          </div>

          <div className='flex items-center'>
            <Label className='w-32 min-w-32 text-sm font-medium'>Lý do hủy</Label>
            <div className='flex-1'>
              <FormField name='ly_do_huy' disabled={formMode === 'view'} placeholder='Nhập lý do hủy lá đơn' />
            </div>
          </div>

          <div className='flex items-center'>
            <Label className='w-32 min-w-32 text-sm font-medium'>Lý do điều chỉnh</Label>
            <div className='flex-1'>
              <FormField
                name='ly_do'
                disabled={formMode === 'view'}
                placeholder='Nhập lý do thay thế hoặc điều chỉnh hóa đơn điện tử'
              />
            </div>
          </div>

          <div className='flex items-center'>
            <FileSelectField
              formMode={formMode}
              className='flex items-center'
              labelClassName='w-32'
              label='Chọn files'
            />
          </div>

          <div className='flex items-center'>
            <Label className='w-32 min-w-32 text-sm font-medium'>Ghi chú</Label>
            <div className='flex-1'>
              <FormField name='ghi_chu' disabled={formMode === 'view'} placeholder='Nhập ghi chú' />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
